export interface IEnvironmentConfig {
  scheme: "http" | "https";
  host: string;
  subscription: string;
  graph: string;
  batch: string;
}

const urls: { [key in string]: IEnvironmentConfig } = {
  development: {
    scheme: "https",
    host: "localhost:8081",
    subscription: "/subscription",
    graph: "/graphql",
    batch: "/graphql/batch",
  },
  test: {
    scheme: "https",
    host: "www.getclockwise.com",
    subscription: "/subscription",
    graph: "/graphql",
    batch: "/graphql/batch",
  },
  staging: {
    scheme: "https",
    host: "www.staging.getclockwise.com",
    subscription: "/subscription",
    graph: "/graphql",
    batch: "/graphql/batch",
  },
  production: {
    scheme: "https",
    host: "www.getclockwise.com",
    subscription: "/subscription",
    graph: "/graphql",
    batch: "/graphql/batch",
  },
};

function getGraphUrlFromEnvironmentConfig(environment: IEnvironmentConfig) {
  return `${environment.scheme}://${environment.host}${environment.graph}`;
}

function getBatchUrlFromEnvironmentConfig(environment: IEnvironmentConfig) {
  return `${environment.scheme}://${environment.host}${environment.batch}`;
}

function getSubscriptionUrlFromEnvironmentConfig(environment: IEnvironmentConfig) {
  const scheme = environment.scheme === "https" ? "wss" : "ws";
  return `${scheme}://${environment.host}${environment.subscription}`;
}

export function getStoredEnvironmentOrDefault(): string {
  return process.env.NODE_ENV!;
}

export function getUrlForStoredEnvironment(): string {
  const storedEnvironment = urls[getStoredEnvironmentOrDefault()];
  return `${storedEnvironment.scheme}://${storedEnvironment.host}`;
}

export function getGraphUrlForEnvironment(environment: string): string {
  return getGraphUrlFromEnvironmentConfig(urls[environment]);
}

export function getGraphUrlForStoredEnvironment(): string {
  const storedEnvironment = getStoredEnvironmentOrDefault();
  return getGraphUrlForEnvironment(storedEnvironment);
}

export function getBatchUrlForEnvironment(environment: string): string {
  return getBatchUrlFromEnvironmentConfig(urls[environment]);
}

export function getBatchUrlForStoredEnvironment(): string {
  const storedEnvironment = getStoredEnvironmentOrDefault();
  return getBatchUrlForEnvironment(storedEnvironment);
}

export function getSubscriptionUrlForEnvironment(environment: string): string {
  return getSubscriptionUrlFromEnvironmentConfig(urls[environment]);
}

export function getSubscriptionUrlForStoredEnvironment(): string {
  const storedEnvironment = getStoredEnvironmentOrDefault();
  return getSubscriptionUrlForEnvironment(storedEnvironment);
}
